import { useMemo } from "react";
import { GenericTableRowTooltip } from "../../../../../common/components/GenericTableRowTooltip";
import { Pricing } from "../../../pricingListSlice";

export function PartiesCell(props: { pricing?: Pricing }): React.ReactElement {
	const { pricing } = props;

	const parties = useMemo(
		() =>
			(pricing?.parties ?? []).map((pricingParty) => {
				if (pricingParty.mirror_book) {
					return `${pricingParty.percentage}%: ${pricingParty?.party?.name} (${pricingParty?.mirror_book?.name})`;
				}
				return `${pricingParty.percentage}%: ${pricingParty?.party?.name}`;
			}),
		[pricing]
	);

	return (
		<>
			{parties?.map((party) => (
				<GenericTableRowTooltip
					key={party}
					value={party}
					sx={{
						alignSelf: "center",
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap",
						width: "100%",
					}}
				/>
			))}
		</>
	);
}
